import React, { useEffect, useState } from "react";
import orderService from "../../services/orderService";
import CrudTable from "../../components/dashboard/table/CrudTable";

import DashboardWrapper from "../../components/DashboardWrapper";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader"; // <-- import Loader

export default function AllNewPendingOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true); // loader state

  const columns = [
     "sl",
    "invoice_id",
    "user_name",
    "city",
    "order_status",
    "payment_status",
    "payment_method",
    "product_qty",
    "amount",
    "order_date",
  ];

  // Fetch new pending orders (last 7 days)
  const fetchOrders = async () => {
    try {
      const response = await orderService.getNewPendingOrders();
      const formattedOrders = response.data.orders.map((o, index) => ({
                sl: index + 1,

        ...o,
        user_name: o.user?.username || "N/A",
        city: o.order_address?.city || "N/A",
        product_qty: o.order_products?.length || 0,

        created_at: o.created_at,
           order_date: new Date(o.created_at).toLocaleString("en-GB", {
          weekday: "short", 
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true, 
        }),
      }));
      setOrders(formattedOrders);
    } catch (error) {
      console.error("Error fetching new pending orders:", error);
    } finally {
      setLoading(false); // stop spinner
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleEdit = (row) => navigate(`/admin/order/${row.id}`);
  const handleDelete = () => {};

  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
            <button
              className="btn btn-secondary d-flex align-items-center"
              onClick={() => navigate(-1)}
            >
             
              <span>Back</span>
            </button>
            </div>
        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="mb-0">New Pending Orders (Last 7 Days)</h4>
          </div>

          <div className="card-body">
            {loading ? (
              <Loader />
            ) : (
              <CrudTable
                data={orders}
                onEdit={handleEdit}
                onDelete={handleDelete}
                columns={columns}
              />
            )}
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
